import { VBadge } from "@/components/ui";
import type { RequestStatus } from "@/domains/requests/api/types";

const STATUS_CONFIG: Record<
  RequestStatus,
  { label: string; color: React.ComponentProps<typeof VBadge>["color"] }
> = {
  draft: { label: "Concept", color: "neutral" },
  submitted: { label: "Ingediend", color: "info" },
  inReview: { label: "In behandeling", color: "warning" },
  awaitingClarification: { label: "Wacht op verduidelijking", color: "warning" },
  approved: { label: "Goedgekeurd", color: "success" },
  rejected: { label: "Afgewezen", color: "error" },
  completed: { label: "Afgerond", color: "secondary" },
};

type RequestStatusBadgeProps = {
  status: RequestStatus;
};

export function RequestStatusBadge({ status }: RequestStatusBadgeProps): React.JSX.Element {
  const { label, color } = STATUS_CONFIG[status];
  return <VBadge color={color}>{label}</VBadge>;
}
